import classNames from "classnames";

import Accordion from "@stadium/ui/src/components/accordion/accordion";

import useWithAnalytics from "@stadium/services/analytics/hooks/use-with-analytics";

import { ANALYTICS_TARGET_REDEMPTION_INFO } from "@constants/analytics/shop";

import styles from "./main.module.scss";

const OrderInstructions = ({ instructions, productId }) => {
  const withAnalytics = useWithAnalytics();

  return (
    <Accordion
      id="redemption-instruction"
      tabIndex={0}
      customClass={classNames(styles.panelGroup, styles.sharedDescriptionWithFlag)}
      onClick={() => {
        withAnalytics(undefined, {
          target: ANALYTICS_TARGET_REDEMPTION_INFO,
          track: true,
          eventProperties: {
            product_id: productId,
          },
        })();
      }}
      titleContent={
        <div className={styles.acord}>
          <div className={styles.primaryColor}>Redemption Instructions</div>
          <div className={`${styles.iconChevronUp} collapseicon`}></div>
        </div>
      }
    >
      <div
        className={styles.panelBodyInfo}
        dangerouslySetInnerHTML={{ __html: instructions }}
      ></div>
    </Accordion>
  );
};

export default OrderInstructions;
